module.exports = __webpack_public_path__ + "img/logo.bed7d6ea.png";